export const UserSessionFilterKey = {
  Revoked: 'revoked',
  ClientId: 'clientId',
} as const;

export type UserSessionFilterKey = (typeof UserSessionFilterKey)[keyof typeof UserSessionFilterKey];

export const USER_SESSION_FILTER_KEYS = [
  UserSessionFilterKey.Revoked,
  UserSessionFilterKey.ClientId,
] as const;
